import { createSlice } from '@reduxjs/toolkit';
import { asyncAuthActions } from './thunks';
import { User } from 'types';

export interface AuthState {
  isSignedIn: boolean;
  currentUser: User | null;
}

export const initialState: AuthState = {
  isSignedIn: false,
  currentUser: null,
};

export const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(asyncAuthActions.signIn.fulfilled, (state) => {
      state.isSignedIn = true;
    });
    builder.addCase(asyncAuthActions.signOut.fulfilled, (state) => {
      state.isSignedIn = false;
    });
    builder.addCase(asyncAuthActions.updatePassword.fulfilled, (state) => {
      state.isSignedIn = true;
    });
    builder.addCase(asyncAuthActions.checkIfUserIsSignedIn.fulfilled, (state) => {
      state.isSignedIn = true;
    });
    builder.addCase(asyncAuthActions.checkIfUserIsSignedIn.rejected, (state) => {
      state.isSignedIn = false;
    });
    builder.addCase(asyncAuthActions.getCurrentUser.fulfilled, (state, action) => {
      state.currentUser = action.payload;
    });
  },
});

export const authActions = { ...slice.actions, ...asyncAuthActions };
export const authReducer = slice.reducer;
